export interface ChriRecordProps {
    chriResult?: ChriResults;
    transactionalInfo: any;
    setEditRedactedMode: Function;
    editRedactedMode: boolean;
    setTextChanges: Function;
    textChanges: boolean;
    chriRetrievalState: ChriRetrievalState;
    setChriRetrievalState: React.Dispatch<React.SetStateAction<ChriRetrievalState>>;
    view: string;
    setView: React.Dispatch<React.SetStateAction<string>>;
    saveRapsheetRedaction: any;
}

export enum ChriRetrievalState {
    SUCCESS = 'SUCCESS',
    FAIL = 'FAIL',
    LOADING = 'LOADING',
    INITIAL = 'INITIAL'
}

export interface ChriResults {
    id: string,
    tcn: string,
    registration_id: string,
    applicant_sid: string,
    version: string,
    response_rapsheet?: string,
    rapsheet_redacted?: string,
    status: ChriStatus,
    source_location: string,
    source_key: string,
    notes?: string,
    requested_by: string,
    insert_date: string,
    modified_date: string,
    request_id: string
}

export enum ChriStatus {
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
    PENDING = "PENDING"
}